import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  endpoint = environment.apiUrl + 'Usuarios/usuario/';
  // endpoint = 'https://localhost:5207/' + 'usuario/';

  constructor(private http: HttpClient) { }


  iniciarSesion(values: any): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}iniciarsesion`,
      JSON.stringify(values)
    );
  }


  modificarPassword(values: any): Observable<any> {
    return this.http.put<any>(
      `${this.endpoint}CambiarContrasena`,
      JSON.stringify(values)
    );
  }
  

  restablecerPassword(values: any): Observable<any> {
    return this.http.put<any>(
      `${this.endpoint}restablecerpassword`,
      JSON.stringify(values)
    );
  }

  emailRestablecerPassword(values: any): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}emailResetPass`,
      JSON.stringify(values)
    );
  }

  deshabilitarLogueado(values: any): Observable<any> {
    return this.http.put<any>(
      `${this.endpoint}deshabilitarlogueado`,
      JSON.stringify(values)
    );
  }
}
